var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResponsiveLayout',{attrs:{"mobileComponent":_vm.CertificateGraphMobile,"desktopComponent":_vm.CertificateGraph}})}
var staticRenderFns = []

export { render, staticRenderFns }